import { render, staticRenderFns } from "./RegistrarAcceso.vue?vue&type=template&id=c4313bf0&scoped=true&"
import script from "./RegistrarAcceso.vue?vue&type=script&lang=js&"
export * from "./RegistrarAcceso.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarAcceso.vue?vue&type=style&index=0&id=c4313bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4313bf0",
  null
  
)

export default component.exports